// utilities
export const UPLOAD_FILE = "/upload";
export const TEACHER_LOOKUP = "/teacher/lookup";
export const PARENT_LOOKUP = "/parent/lookup";
export const ASSESSMENT_TYPES = "/assesment-types";
export const DISCIPLINE_AREAS = "/discipline/areas";
export const DISCIPLINE_TAGS = '/discipline/tags'
export const DISCIPLINE_AREA_GOALS = "/discipline/area/goals";
export const GOAL_CONTEXTS = "/discipline/area/goal/contexts";
export const FORMAL_ASSESSMENTS = "/formal-assesments"
export const AUTOCOMPLETE = "/autocomplete";
export const FUNDING_SOURCE_UTILITY_LIST = "/funding-source";
export const PROGRAM_LOOKUP = "/programs-assigned";
export const CHATTER_PROGRAM_CLIENT_LOOKUP = "/program/client";
export const CLIENT_LOOKUP = "/client";
export const LESSONS_LIST = "/lessons";
export const SCHOOL_LOOKUP = "/schools";
export const THERAPIST_LOOKUP = "/therapist/lookup";
export const STAFF_LOOKUP = "/support_staff";
export const APPRENTICE_LOOKUP = "/apprentice";
export const DISCIPLINES_LOOKUP = "/disciplines";
export const SCHOOL_TEACHER_LOOKUP = "/teachers";
export const CLIENT_GUARDIANS_LOOKUP = "/client/guardians";
export const CLIENT_SERVICE_STATUS_LOOKUP = "/status";
export const ASSIGNED_SCHOOLS_LOOKUP = '/assignedschools'
export const ASSIGNED_SCHOOL_DIVISIONS_LOOKUP = '/assigneddivisions'
export const SUBADMIN_LOOKUP = '/sub_admin/lookup'
export const SUPERADMIN_LOOKUP = '/admin/lookup'


// authentication
export const LOGIN = "/login";
export const LOGOUT = "/logout";
export const FORGOT_PASSWORD = "/forgotPassword";
export const RESET_PASSWORD = "/resetPassword";

// Admin dashboard
export const GET_DASHBOARD_DATA = "/dashboard";

// Disciplines
export const LIST_DISCIPLINE = "/list";
export const CREATE_DISCIPLINE = "/create";
export const VIEW_DISCIPLINE = "/view";
export const UPDATE_DISCIPLINE = "/update";
export const REMOVE_DISCIPLINE = "/remove";

// goals
export const LIST_GOAL = "/list";
export const CREATE_GOAL = "/create";
export const VIEW_GOAL = "/view";
export const UPDATE_GOAL = "/update";
export const REMOVE_GOAL = "/remove";

// designations
export const LIST_DESIGNATION = "/list";
export const CREATE_DESIGNATION = "/create";
export const VIEW_DESIGNATION = "/view";
export const UPDATE_DESIGNATION = "/update";
export const REMOVE_DESIGNATION = "/remove";

// therapist profiles
export const LIST_THERAPIST = "/list";
export const CREATE_THERAPIST = "/create";
export const VIEW_THERAPIST = "/view";
export const UPDATE_THERAPIST = "/update";
export const REMOVE_THERAPIST = "/remove";

// School Divisons
export const LIST_SCHOOL_DIVISON = "/list";
export const CREATE_SCHOOL_DIVISON = "/create";
export const VIEW_SCHOOL_DIVISON = "/view";
export const UPDATE_SCHOOL_DIVISON = "/update";
export const REMOVE_SCHOOL_DIVISON = "/remove";

// Schools
export const LIST_SCHOOL = "/list";
export const CREATE_SCHOOL = "/create";
export const VIEW_SCHOOL = "/view";
export const UPDATE_SCHOOL = "/update";
export const REMOVE_SCHOOL = "/remove";


// Clients
// School clients
// Schools
export const LIST_SCHOOL_CLIENT = "/list";
export const CREATE_SCHOOL_CLIENT = "/create";
export const VIEW_SCHOOL_CLIENT = "/view";
export const UPDATE_SCHOOL_CLIENT = "/update";
export const REMOVE_SCHOOL_CLIENT = "/remove";
export const FAVOURITE_SCHOOL_CLIENT = '/favorite/update'

// Chatter Clients
export const CHATTER_CLIENT_LIST = "/list"
export const CHATTER_CLIENT_DETAIL = "/detail"
export const CHATTER_CLIENT_UPDATE = "/update"
export const CHATTER_PROGRAMS_ASSIGNED = '/allMemberPrograms'
export const FAVOURITE_CHATTER_CLIENT = '/favorite/update'
export const CHATTER_CLIENT_ATTENDANCE_LIST = '/attendence'


// Home Education
export const HOME_EDUCATION_CLIENT_LIST = "/list"
export const HOME_EDUCATION_CLIENT_DETAIL = "/detail"
export const HOME_EDUCATION_CLIENT_UPDATE = "/update"
export const FAVOURITE_HOME_CLIENT = '/favorite/update'

// Private CLient
export const PRIVATE_CLIENT_LIST = "/list"
export const PRIVATE_CLIENT_DETAIL = "/detail"
export const PRIVATE_CLIENT_UPDATE = "/update";
export const FAVOURITE_PRIVATE_CLIENT = '/favorite/update'
export const SHARE_LINKS_PRIVATE_CLIENT = '/shared-links'

// caseload management
export const ASSIGN_THERAPIST = "/therapist/assign";
export const REMOVE_THERAPIST_ASSIGNMENT = "/therapist/assigned";
export const LIST_CLIENT_CASELOADS = '/history/list'
export const UPDATE_THERAPIST_SERVICE_STATUS = "/therapist/assessment/servicestatusupdate"

// Cms Page
export const GET_CMS_PAGE_CONTENT = "/get-cms-page";

// MDT Assessment
export const MDT_ASSESSMENT_LIST = "/caseload/list";
export const MDT_ASSESSMENT_STATUS_UPDATE = "/caseload/update-status";
export const MDT_ASSESSMENT_VIEW = "/caseload/view";
export const MDT_ASSIGN_CHECKLIST = "/checklist/create";
export const MDT_ASSESSMENT_UPDATE = "/caseload/update";
export const MDT_CHECKLIST_UPDATE = "/caseload/checklist/update";

// Note
export const MANAGE_NOTE_ADD = "/create";
export const MANAGE_NOTE_EDIT = "/update";
export const MANAGE_NOTE_VIEW = "/detail";
export const MANAGE_NOTE_REMOVE = "/remove";
export const MANAGE_NOTE_PIN = "/pin-top";
export const MANAGE_NOTES_V2 = {
    CREATE: "/note/create_v2",
    LIST: "/note/list_v2",
    UPDATE: '/note/update_v2',
    VIEW: '/note/view',
    DELETE: '/note/remove_v2',
    ACCEPT_SUGGESTION: '/note/suggesion',
    COMMENTS: {
        CREATE: "/note/suggesion/add",
        UPDATE: "/note/suggesion/edit",
        DELETE: "/note/suggesion/delete",
        LIST: "/note/suggesion/search",
    }
}

// Attendance
export const ADD_ATTENDANCE = "/create";
export const UPDATE_ATTENDANCE = "/update";
export const DELETE_ATTENDANCE = "/remove";

// Resource
export const MANAGE_RESOURCE_LIST = "/list";
export const MANAGE_RESOURCE_ADD = "/create";
export const MANAGE_RESOURCE_DELETE = "/remove";

// Group
export const MANAGE_GROUP_LIST = "/list";
export const MANAGE_GROUP_ADD = "/create";
export const MANAGE_GROUP_DELETE = "/remove"
export const MANAGE_GROUP_VIEW = "/view"
export const MANAGE_GROUP_UPDATE = "/update"
export const MANAGE_GROUP_REMOVE_MEMBER = "/remove-member"

// Discharge

// Group
export const MANAGE_DISCHARGE_LIST = "/list";
export const MANAGE_DISCHARGE_VIEW = "/view"
export const MANAGE_DISCAHARGE_LIST_NEW = '/listnew'

// Chatter Program
export const MANAGE_CHATTER_PROGRAM_LIST = "/list";
export const MANAGE_CHATTER_PROGRAM_VIEW = "/view";
export const MANAGE_CHATTER_PROGRAM_REMOVE_LESSON = "/lesson"
export const MANAGE_CHATTER_PROGRAM_EDIT = "/update";
export const MANAGE_CHATTER_PROGRAM_ATTENDANCE = "/attendance";

// Chatter Program Attendance
export const MANAGE_CHATTER_PROGRAM_ATTENDANCE_LIST = "/members/list";

// Lesson
export const MANAGE_LESSON_LIST = "/list";
export const MANAGE_LESSON_DELETE = "/remove";
export const MANAGE_LESSON_ADD = "/create";
export const MANAGE_LESSON_EDIT = "/update";
export const MANAGE_LESSON_VIEW = "/view";
export const MANAGE_LESSON_REMOVE_FILE = "/file/remove";
export const MANAGE_LESSON_SHARE = "/share";
export const MANAGE_LESSON_SHARED_LIST = "/shared/list";

// CLassroom Consultation
export const MANAGE_CLASSROOM_CONSULTATION_LIST = "/list";
export const MANAGE_CLASSROOM_CONSULTATION_ADD = "/create";
export const MANAGE_CLASSROOM_CONSULTATION_VIEW = "/view";
export const MANAGE_CLASSROOM_CONSULTATION_EDIT = "/update";
export const MANAGE_CLASSROOM_CONSULTATION_DELETE = "/remove";
export const MANAGE_CLASSROOM_CONSULTATION_FEEDBACK = "/feedback";
export const MANAGE_CLASSROOM_CONSULTATION_SUBMIT = "/submit-feedback";

// Classroom Reports
export const MANAGE_CLASSROOM_REPORTS_LIST = "/report-list";
export const MANAGE_FAVOURITE_REPORT = '/report-favorite-unfavorite'
export const CREATE_CLASSROOM_REPORT_COPY = '/copy'
export const DELETE_CLASSROOM_REPORT = '/remove-report'
export const START_NEW_REPORT = '/report-submit'
export const VIEW_CLASSROOM_REPORT = '/view'

// Staff
export const MANAGE_STAFF_LIST = "/guardian/list";
export const MANAGE_STAFF_ADD = "/create";
export const MANAGE_STAFF_CLIENTS_LIST = "/guardian/clients";
export const MANAGE_STAFF_TASKS_LIST = "/guardian/client/tasks";
export const MANAGE_STAFF_TASKS_LIST_LOOKUP = "/list";
export const MANAGE_STAFF_DELETE_TASK = "/remove";
export const MANAGE_STAFF_CONSENT_LOOKUP = "/guardian/consent-form/assign";
export const MANAGE_STAFF_ASSIGN_CONSENT_LOOKUP = "/guardian/consent-form/assign";
export const MANAGE_STAFF_REMOVE_CONSENT_LOOKUP = "/guardian/consent-form/remove";
export const MANAGE_STAFF_GROUPS_LIST = '/staff/tasklist/group'
export const MANAGE_STAFF_GROUP_TASKS_LIST = "/staff/group"
export const MANAGE_STAFF_GROUP_TASKS_SESSION_VIEW = '/staff/get-group-progress'
export const MANAGE_STAFF_TASK_STATUS_UPDATE = '/targetstatus/update'
export const MANAGE_STAFF_GROUP_TASK_STATUS_UPDATE = '/group/targetstatus/update'
export const MANAGE_STAFF_GET_POPULATE_TASKS_LIST = '/list/lookup'
export const MANAGE_STAFF_UPDATE_CLIENT_ATTENDANCE = '/taskprogress/attendence/update'
export const MANAGE_STAFF_GUARDIANS_LIST = '/guardian/parent/list'
export const MANAGE_STAFF_GUARDIAN_CLIENTS_LIST = '/guardian/parent/clients'

export const STAFF_TASKS_TEMPLATES_LIST = '/template/tasklist'
export const STAFF_TASKS_TEMPLATES_ADD = '/template/create'
export const STAFF_TASKS_TEMPLATES_DELETE = '/template/remove'
export const STAFF_TASKS_TEMPLATES_VIEW = '/template/view'
export const STAFF_TASKS_TEMPLATES_UPDATE = '/template/update'

export const STAFF_TASKS_SUBMIT_SESSION = '/submit-progress/:taskId/:staffId/:clientId'
export const STAFF_GROUP_TASKS_SUBMIT_SESSION = '/submit-group-progress/:staffId/:taskId'

export const STAFF_TASKS_SAVE_SESSION = '/save-progress/:taskId/:staffId/:clientId'
export const STAFF_GROUP_TASKS_SAVE_SESSION = '/save-group-progress/:staffId/:taskId'

// Chat
export const GET_CHAT = "/api/v1/caseload-chat/get-messages";

// Apprentice
export const ASSIGN_APPRENTICE = "/assign/apprentice";
export const UNASSIGN_APPRENTICE = "/unassign/apprentice";

export const EVALUATE_PEER = "/apprentice/chatter/evaluate";
export const CHATTER_PEER_SHARE_EVALUATION = "/member/share/evaluation";

// Attachment
export const ATTACH_DOCUMENT = "/add-attachment";
export const PUBLISH_DOCUMENT = "/publish-report";

// Team
export const MANAGE_TEAM_LIST = "/list";
export const MANAGE_TEAM_ADD = "/create";
export const MANAGE_TEAM_DELETE = "/remove";

// Appointment
export const MANAGE_APPOINTMENT_LIST = "/list";
export const MANAGE_APPOINTMENT_UPDATE_WORKING_HOURS = "/working-hours";
export const MANAGE_APPOINTMENT_UPDATE_STATUS = "/status";
export const MANAGE_APPOINTMENT_CREATE = "/create";
export const MANAGE_APPOINTMENT_REMOVE = "/remove";
export const UPDATE_APPOINTMENT_COUNT = "/free_appointments"
export const MANAGE_APPOINTMENT_UPDATE = "/update";
export const MANAGE_APPOINTMENT_QUESTION_CREATE = "/question/create"
export const MANAGE_APPOINTMENT_QUESTIONS_LIST = "/form/view"
export const MANAGE_APPOINTMENT_QUESTION_DELETE = '/question/delete'
export const MANAGE_APPOINTMENT_QUESTION_UPDATE = '/question/update'
export const MANAGE_APPOINTMENT_GUARDIAN_SUBMITTED_FORM_VIEW = '/submittedform/view'

export const CONSENT_FORMS_LIST = '/consent-forms/list'
export const CONSNET_FORM_VIEW = '/consent-forms/view'

// Appointment Balance
export const GET_APPOINTMENT_BALANCE = "/free-balance/:clientId"


export const LIST_REPORTS = '/parent/client/reports'
export const LIST_CLIENT_DETAILS_REPORTS = '/parent/clients/reports'
export const REPORT_OPTIONS = '/assesment-types'
export const FAVOURITE_REPORT = '/update_fav_unfav/assesment'


// REPORTS v2

// SCHOOL REPORTS
export const GET_REPORT_ASSESMENT_FEEDBACK = 'assesment/feedback'
export const SUBMIT_SCHOOL_DISCHARGE_SCREENING_REPORT = '/school/assesment-submit/feedback'
export const SUBMIT_INDIVIDUAL_SESSION_REPORT = '/individual/report-submit'
export const SUBMIT_CONSULTATION_REPORT = '/consultation-plan/report-submit'
export const SUBMIT_ASSESSMENT_REPORT = '/assessment-report/report-submit'
export const LIST_CLASSROOM_REPORTS = '/list'
export const ADD_ASSESSMENT_GOALS_STRATEGY = "/school/assesment-goals-strategy/create"
export const DELETE_ASSESSMENT_GOALS_STRATEGY = "/school/assesment-goals-strategy/remove"
export const COPY_REPORTS = '/:clientType/report-copy/feedback/:assessmentId/:clientId/:reportType/:reportId/:screening_date'
export const CREATE_BLANK_REPORT = '/:clientType/new-report/:assessmentId/:clientId'
export const DELETE_CLIENT_REPORT = '/:clientType/report-delete/:reportType/:reportId'

// CHATTER REPORTS 
export const SUBMIT_CHATTER_CONSULTATION_REPORT = '/chatter/chatter-summary-report/report-submit'
export const CHATTER_REPORTS_PROGRAM_LIST = '/chatter/template/list'
export const CREATE_CHATTER_SUMMARY_GOAL = '/chatter-program-goals/create'


// report formal assessment templates
export const FORMAL_ASSESSMENT_TEMPLATES_LIST = "/formal-assessment/template/list";

// DAIGNOSIS AND SEVERITY 
export const DIAGNOSIS_SERVERITY_LIST = '/parent/client/diagonis_reports'

// WORKSHOPS
export const WORKSHOP_CREATE = '/workshop/create'
export const WORKSHOP_UPDATE = '/workshop/update'
export const WORKSHOP_LIST = '/workshop/list'
export const WORKSHOP_VIEW = '/workshop/view'
export const WORKSHOP_DELETE = '/workshop/remove'
export const WORKSHOP_COPY = '/workshop/copy'

// CLINICIANS HISTORY 
export const CLINICIAN_HISTORY_LIST = '/clinical/history/list'

export const CHANGE_PASSWORD = '/change/password'

